module.exports = __webpack_public_path__ + "img/ft_beet_pulp.67d93cf6.jpg";